// Qualité procédurale d'un camp du dossier. Texte libre en base :
// cette liste ne sert que de suggestions à la saisie.
export const PROCEDURAL_ROLE_SUGGESTIONS = [
  'Demandeur',
  'Défendeur',
  'Appelant',
  'Intimé',
  'Intervenant volontaire',
  'Intervenant forcé',
  'Requérant',
  'Partie civile',
] as const;

export function normalizeProceduralRole(value: string | null | undefined): string | null {
  const trimmed = (value ?? '').replace(/\s+/g, ' ').trim();
  return trimmed.length > 0 ? trimmed : null;
}
